import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from '../shared/services/auth-guard.service';

import { SettingsComponent } from './settings/settings.component';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuardService],
  },
];

export const SettingsRouting = RouterModule.forChild(settingsRoutes);
